import { useRef } from "react";
import Join from "./Join";

function About() {
  return (
    <div className="about-us">
      <h1>About Us</h1>
      <p>
        Renters Action Network (RAN) is a grassroots organization dedicated to
        advocating, fighting for and organizing tenants to build revolutionary
        tenant unions in Portland Oregon. We believe that safe, affordable,
        guaranteed housing is a fundamental human right, not a privilege and can
        only be achieved by organizing the masses.
        <h2>Our Points of Unity</h2>
        <ol>
          <li>
            <h3>We oppose compromise, collaboration, and capitulation.</h3>
            <p>
              Our interests as the working class are ultimately irreconcilable
              with the interests of landlords, developers, and bankers. We want
              housing and they want money. We must recognize that our struggle
              is not over until housing is no longer a commodity wielded by the
              capitalist class against the working class. If we do negotiate
              with representatives of the capitalist class, we must do so in a
              principled manner, and bear in mind that no concession on their
              part means that the struggle is concluded. This requires keeping
              our principles and political lines at the forefront of our
              engagement, keeping our revolutionary aims primary to economic
              gains, and never capitulating capitalists’ interests against our
              own.  We will not collaborate with the state or the capitalists by
              endorsing any politician, ballot initiative, or electoral
              campaign, or partaking in any form of legislative organizing.
              Therefore we do not sign onto demands or actions that are against
              these principles, even if we support the organizations or people
              making the demands. The power to choose who betrays us is no power
              at all, but the power of collective action is one of the strongest
              weapons we have to unite the working class against our enemies.
            </p>
          </li>
          <li>
            <h3>
              Our primary task is to raise class consciousness and bring working
              class people into revolutionary organizing.
            </h3>
            <p>
              Our strategies of bringing working class people together, building
              combative tenant networks, taking collective action, and
              organizing amongst the masses is ultimately to bring the masses
              into revolutionary organizing. When we say “class consciousness,”
              we are referring to developing and raising the awareness that we
              as the working class are being exploited by the capitalist class,
              and that we must unite against class enemies, capitalists and the
              state and police that serve them, to overthrow the system that
              keeps us from our basic needs, exploits us, and represses us. 
            </p>
          </li>
        </ol>
        {/* <button className="join-us-button">Join us</button> in our mission to create a more just and equitable housing landscape for all. */}
      </p>
      <Join />
    </div>
  );
}

export default About;
